<template>
	<div class="image-card" @click="goDetail">
		<img :src="image.logo" alt="图片">
	</div>
</template>

<script>
export default {
	name: 'ImageCard',
	props: {
		image: {
			type: Object,
			required: true
		}
	},
	methods: {
		goDetail() {
			this.$emit('set-image', this.image);
		}
	}
};
</script>

<style lang="scss" scoped>
.image-card {
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	transition: all 0.3s;
	cursor: pointer;
	
	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	}
	
	img {
		width: 100%;
		height: auto;
		display: block;
		object-fit: cover;
		border-radius: 8px;
	}
}
</style>